import { BetaFeatures } from './components';

export const Portals = () => {
  return <BetaFeatures />;
};
